export default __webpack_public_path__ + "static/media/Christie_Lazo_AHV_In_Moms_We_Trust.33c921b1.jpg";